import styled from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'
import { IoClose as CloseIcon } from 'react-icons/io5'

interface Props {
  onClick: (e: React.MouseEvent) => void
}

const CloseButton = ({ onClick }: Props) => {
  const handleClick = (e: React.MouseEvent) => {
    onClick(e)
  }

  return (
    <Container
      data-testid='closeButton'
      onClick={handleClick}
      aria-label='Close modal'
    >
      <CloseIcon />
    </Container>
  )
}

const Container = styled.button<StyledHTMLElement>(({ theme }) => ({
  position: 'fixed',
  padding: '4px',
  top: '24px',
  right: '24px',
  borderRadius: '50%',
  // hexadecimal 66 -> opcacity: 40%
  background: '#FFFFFF66',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: theme?.zIndex?.productModal,
  border: 'none',
  outline: 'none',

  '&:hover': {
    // hexadecimal 99 -> opcacity: 60%
    background: '#EFEFF099'
  },
  '&:active': {
    // hexadecimal CC -> opcacity: 80%
    background: '#D8D8D8CC'
  },
  '> svg': {
    display: 'block',
    height: '20px',
    width: '20px'
  },
  '> svg > path': {
    fill: theme.colors['primary'],
    // 20px container causes the icon path to be w:10.63 h: 10.63
    // we want the icon to be 14px so we can scale it. (14 / 10.63 = 1.317)
    scale: '1.317',
    transformOrigin: 'center'
  }
}))

export default CloseButton
